export default __webpack_public_path__ + "static/media/bannerImage.23e90ff2.png";